
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zpravy",
      function () {
        return require("private-next-pages/zpravy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zpravy"])
      });
    }
  